import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '@/App';
import '@/index.css';
import '@/styles/care-guides.css';
import { Buffer } from 'buffer';

// This is required for pdf-parse to work in the browser
window.Buffer = Buffer;

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);

root.render(
  <App />
);